import {catRoutes} from "./catRoutes";
import {sitRoutes} from "../sit/routing/sitRoutes";

export type RouteKey = keyof typeof routes | keyof typeof sitRoutes;

export const routes = {
    ...catRoutes,
    ...sitRoutes,
}
